import script from "./ModalDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDialog.vue?vue&type=script&setup=true&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=2a690a9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a690a9e"]])

export default __exports__